import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 18"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M1.31 16.5c-.09 0-.18-.03-.26-.07A.497.497 0 0 1 .81 16V3.4c0-1.05.85-1.9 1.9-1.9h8.4c1.05 0 1.9.85 1.9 1.9V16c0 .17-.09.33-.24.43-.15.09-.33.1-.49.02L6.9 13.76l-5.38 2.69c-.06.03-.14.05-.21.05zm1.4-14c-.5 0-.9.4-.9.9v11.79l4.88-2.44c.14-.07.31-.07.45 0L12 15.19V3.4c0-.5-.4-.9-.9-.9H2.71z"
    }, null, -1)
  ])))
}
export default { render };